import { InputDate } from './InputDate';
import { InputFile } from './InputFile';
import { InputText } from './InputText';
import { InputTextArea } from './InputTextArea';
import { InputTime } from './InputTime';

export const Input = {
  Text: InputText,
  Date: InputDate,
  File: InputFile,
  TextArea: InputTextArea,
  Time: InputTime,
};
